import { render, staticRenderFns } from "./SEOSection.vue?vue&type=template&id=6e54b1f8&scoped=true"
import script from "./SEOSection.vue?vue&type=script&lang=js"
export * from "./SEOSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54b1f8",
  null
  
)

export default component.exports